import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.gas-cards';

const buildLinkRow = (name, href) => {
  if (!name) return '';
  const tag = href ? 'a' : 'span';
  const hrefAttr = href ? ` href="${href}"` : '';
  return /* html */ `
    <${tag} class="gas-cards__link"${hrefAttr}>
      <span class="gas-cards__link-name">${name}</span>
      <span class="gas-cards__link-arrow">&gt;</span>
    </${tag}>`;
};

/**
 * Module Init — markup
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        const links = [
          buildLinkRow(item.item1_name, item.item1_link),
          buildLinkRow(item.item2_name, item.item2_link),
          buildLinkRow(item.item3_name, item.item3_link),
        ].join('');

        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="gas-cards__card">
              ${item.image ? `<div class="gas-cards__image-wrapper">
                <img class="gas-cards__image" src="${item.image}" alt="${item.title || ''}" loading="lazy">
              </div>` : ''}
              <div class="gas-cards__content">
                ${item.title ? `<h3 class="gas-cards__card-title">${item.title}</h3>` : ''}
                ${links ? `<div class="gas-cards__links">${links}</div>` : ''}
                ${item.link ? `<a class="gas-cards__button btn-custom primary" href="${item.link}">Shop All</a>` : ''}
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Module Init — Splide
 */
(() => {
  document.querySelectorAll(`${moduleSelector} .splide`).forEach((item) => {
    const slideCount = item.querySelectorAll('.splide__slide').length;

    const slider = new Splide(item, {
      type: 'slider',
      rewind: true,
      perPage: 6,
      perMove: 1,
      gap: 20,
      pagination: false,
      drag: slideCount > 6,
      arrows: slideCount > 6,
      breakpoints: {
        1860: {
          perPage: 5,
          drag: slideCount > 5,
          arrows: slideCount > 5,
        },
        1550: {
          perPage: 4,
          drag: slideCount > 4,
          arrows: slideCount > 4,
        },
        1250: {
          perPage: 3,
          drag: slideCount > 3,
          arrows: slideCount > 3,
        },
        930: {
          perPage: 2,
          drag: slideCount > 2,
          arrows: slideCount > 2,
        },
        640: {
          perPage: 1,
          drag: slideCount > 1,
          arrows: slideCount > 1,
        },
      },
    });
    slider.mount();
  });
})();
